<template>
  <Table>
    <Row header>
      <Cell>Player</Cell>
      <Cell v-tooltip="'Won With'">WW</Cell>
      <Cell v-tooltip="'Lost With'">LW</Cell>
      <Cell v-tooltip="'Won Against'">WA</Cell>
      <Cell v-tooltip="'Lost Against'">LA</Cell>
    </Row>

    <Row
      v-for="(peer, index) in peers"
      :to="decodeURI (resolve ({ name: 'playerProfile', params: { name: peer.name } }))"
    >
      <Cell>{{ battleTag (peer.name) }}</Cell>

      <Cell
        v-for="key in [ 'wonWith', 'lostWith', 'wonAgainst', 'lostAgainst' ]"
      >
        {{ peer [key] }}
        <Bar width="50px" :fill="relative (key, peer, peers)"></Bar>
      </Cell>
    </Row>
  </Table>
</template>

<script>
  import { Table, Row, Cell } from '@/legacy/components/widgets/Table';
  import Bar from '@/legacy/components/widgets/Bar';
  import { relative } from '@/legacy/lib//util';
  import { battleTag } from '@/legacy/lib/template';
  import { resolve } from '@/legacy/router';

  export default {
    components: {
      Table,
      Row,
      Cell,
      Bar
    },

    methods: {
      relative,
      resolve,
      battleTag
    },

    props: {
      peers: {
        type: Array
      }
    }
  };
</script>